import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

export const MessageRoleSchema = z.enum(['customer', 'rep_sent', 'rep_note']);
export type MessageRole = z.infer<typeof MessageRoleSchema>;

export const EditDiffSchema = z
  .object({
    addedChars: z.number().int().min(0),
    removedChars: z.number().int().min(0),
    similarity: z.number().min(0).max(1),
  })
  .nullable();
export type EditDiff = z.infer<typeof EditDiffSchema>;

export const MessageSchema = z.object({
  id: IdSchema,
  conversationId: IdSchema,
  role: MessageRoleSchema,
  content: z.string(),
  sourceDraftId: IdSchema.nullable(),
  wasEdited: z.boolean(),
  editDiff: EditDiffSchema,
  sentAt: TimestampSchema.nullable(),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type Message = z.infer<typeof MessageSchema>;

// POST /conversations/:id/messages — customer reply or rep_note
export const AddInboundMessageSchema = z.object({
  role: z.enum(['customer', 'rep_note']),
  content: z.string().min(1),
  sentAt: z.coerce.date().optional(),
});
export type AddInboundMessageInput = z.infer<typeof AddInboundMessageSchema>;

// POST /conversations/:id/messages/sent — rep marks a draft sent (with or without edits)
export const LogSentMessageSchema = z.object({
  content: z.string().min(1),
  sourceDraftId: IdSchema.optional(), // omitted if rep sent something out-of-band
  sentAt: z.coerce.date().optional(),
});
export type LogSentMessageInput = z.infer<typeof LogSentMessageSchema>;
